if (!customElements.get('olane-latest')) {
  customElements.define('olane-latest', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[data-olane-tab]'));
      this.products = this.querySelector('[data-olane-products]');
      this.status = this.querySelector('[data-olane-status]');
      this.errorLink = this.querySelector('[data-olane-error-link]');
      this.links = this.querySelectorAll('[data-olane-view-all]');
      this.activeTab = this.tabs.find(tab => tab.getAttribute('aria-current') === 'true');
      this.cache = new Map();
      this.sequence = 0;
      if (!this.products || !this.activeTab) return;
      this.cache.set(this.activeTab.href, this.products.innerHTML);
      this.handleClick = event => {
        const tab = event.target.closest('[data-olane-tab]');
        if (!tab || !this.contains(tab) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.selectCategory(tab);
      };
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.request?.abort();
      this.sequence += 1;
      this.removeEventListener('click', this.handleClick);
      this.initialized = false;
    }

    async selectCategory(tab) {
      this.request?.abort();
      const sequence = ++this.sequence;
      if (this.errorLink) this.errorLink.hidden = true;
      this.status.textContent = '';
      if (tab === this.activeTab) {
        this.setLoading(false);
        return;
      }
      this.setLoading(true);
      this.status.textContent = this.dataset.loadingMessage || 'Loading styles…';
      try {
        let html = this.cache.get(tab.href);
        if (!html) {
          this.request = new AbortController();
          const url = new URL(tab.href);
          url.searchParams.set('view', 'olane-home-grid');
          const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, { signal: this.request.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Category request failed');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const products = document.querySelector('[data-olane-products]');
          if (!products?.querySelector('.olane-latest__grid')) throw new Error('Category grid missing');
          html = products.innerHTML;
          this.cache.set(tab.href, html);
        }
        if (sequence !== this.sequence || !this.isConnected) return;
        this.products.innerHTML = html;
        this.tabs.forEach(item => {
          if (item === tab) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        this.links.forEach(link => link.setAttribute('href', tab.getAttribute('href')));
        this.activeTab = tab;
        this.status.textContent = `${this.dataset.loadedMessage || 'Styles loaded:'} ${tab.textContent.trim()}`;
        this.dispatchEvent(new CustomEvent('on:olane-latest:updated', { bubbles: true }));
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== this.sequence || !this.isConnected) return;
        this.status.textContent = this.dataset.errorMessage || 'Unable to load styles. Open the collection to continue.';
        if (this.errorLink) {
          this.errorLink.href = tab.href;
          this.errorLink.hidden = false;
        }
      } finally {
        if (sequence === this.sequence && this.isConnected) this.setLoading(false);
      }
    }

    setLoading(loading) {
      this.products.setAttribute('aria-busy', String(loading));
      this.classList.toggle('olane-latest--loading', loading);
    }
  });
}
